import { forwardRef, type SVGProps } from 'react';
import { cn } from '../lib/utils';

export const IconBase = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, children, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn('size-4 shrink-0', className)}
      {...props}
    >
      {children}
    </svg>
  )
);
IconBase.displayName = 'IconBase';
